<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export default {
  name: 'App',
  mounted() {
    // 注册GSAP ScrollTrigger插件
    gsap.registerPlugin(ScrollTrigger)
    
    // 初始化滚动动画
    this.initScrollAnimations()
  },
  updated() {
    // 路由切换后重新初始化滚动动画
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      // 为所有需要滚动动画的元素添加动画
      const scrollElements = document.querySelectorAll('.scroll-animate')
      
      scrollElements.forEach(element => {
        gsap.fromTo(element, 
          { opacity: 0, y: 30 },
          { 
            opacity: 1, 
            y: 0, 
            duration: 0.8, 
            scrollTrigger: {
              trigger: element,
              start: 'top 80%',
              end: 'bottom 20%',
              toggleActions: 'play none none reverse'
            }
          }
        )
      })
    }
  }
}
</script>

<style>
/* 全局样式变量 */
:root {
  --primary-color: #0052d9;
  --secondary-color: #00a0e9;
  --accent-color: #e60012;
  --text-color: #333333;
  --bg-color: #f5f5f5;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
  color: var(--text-color);
  background-color: #ffffff;
}

/* 自定义工具类 */
.text-gradient {
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bg-gradient {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
}

/* 滚动动画 */
.scroll-animate {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

/* 响应式容器 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>
